module.exports = __webpack_public_path__ + "img/where-to-buy-xs.a3262c89.png";